import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { McpApiService } from '../mcp-api';
import type {
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
} from '../../types';

@injectable()
export class McpApiServiceImpl extends PsHttpService implements McpApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/hub-api/web/mcp`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getList() {
        return this.get<PatSnapCommonResponseData<WebMcpListResponse>>({
            url: '/list',
        }).then(res => res.data as WebMcpListResponse);
    }

    getDetail(name: string) {
        return this.get<PatSnapCommonResponseData<WebMcpDetailItem>>({
            url: `/${encodeURIComponent(name)}`,
        }).then(res => res.data as WebMcpDetailItem);
    }

    enable(name: string) {
        return this.post<PatSnapCommonResponseData<WebMcpEnableData>>({
            url: `/${encodeURIComponent(name)}/enable`,
        }).then(res => res.data as WebMcpEnableData);
    }

    disable(name: string) {
        return this.post<PatSnapCommonResponseData<WebMcpEnableData>>({
            url: `/${encodeURIComponent(name)}/disable`,
        }).then(res => res.data as WebMcpEnableData);
    }
}
